// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1YfZa{display:block;margin-top:2.4rem}", ""]);
// Exports
exports.locals = {
	"info2": "_1YfZa"
};
module.exports = exports;
